import { addNativeRoutingToProductUrl } from '~/helpers/routes/nativeRouting/transformProductsForNativeRouting';
import { CountryCodeValue } from '~/types/localization/localizationHelperTypes';

export const cleanBloomreachImageUrl = (imageUrl: string): string => {
  const url = new URL(imageUrl);
  return `${url.origin}${url.pathname}`;
};

export const prepareBloomreachProductPath = (productUrl: string, countryCode: CountryCodeValue): string => {
  const url = new URL(productUrl);
  const fullPath = `${url.pathname}${url.search}`;
  const adjustedUrl = addNativeRoutingToProductUrl(fullPath, countryCode);
  return adjustedUrl;
};
